import MainLogo from 'assets/images/logo.png';

const footerLinks: any[] | [] = [
    // { label: "FAQ's", href: '#' },
    // { label: 'Video Tutorial', href: '#' },
    // { label: 'Glossary', href: '#' },
    // { label: 'Contact Support', href: '#' },
];

export const Footer = () => {
    return (
        <footer className="w-full border-t bg-white">
            <div className="flex flex-col md:flex-row md:h-16 items-center justify-center md:justify-between px-6 py-4 md:py-0 gap-4 md:gap-0 relative">
                <div className="flex items-center gap-3">
                    <span className="text-fontGray font-medium text-xs">Powered by</span>
                    <img className="h-7 md:h-8" src={MainLogo} alt="Asper Logo" />
                </div>

                <nav className="flex flex-col md:flex-row  gap-3 md:gap-6 md:absolute md:left-1/2 md:transform md:-translate-x-1/2">
                    {footerLinks?.length
                        ? footerLinks.map((link) => (
                              <a
                                  key={link.label}
                                  href={link.href}
                                  className="text-sm text-muted-foreground hover:text-foreground transition-colors underline underline-offset-4 whitespace-nowrap"
                              >
                                  {link.label}
                              </a>
                          ))
                        : null}
                </nav>
            </div>
        </footer>
    );
};
